import React from 'react';

const SvgComponent = props => (
  <svg width={16} height={16} {...props}>
    <g stroke={'currentColor'} fill="none" fillRule="evenodd">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5.5 4.5l5 4-5 4"
      />
    </g>
  </svg>
);

export default SvgComponent;
